module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/confirm-window/confirm-window.component.css
// module id = ./src/app/components/confirm-window/confirm-window.component.css
// module chunks = main